import { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { Menu, X } from "lucide-react";
import Logo from "./Logo";

const navItems = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Services", to: "/services" },
  { label: "Our Approach", to: "/approach" },
  { label: "Contact", to: "/contact" },
];

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <header
      data-testid="navbar"
      className="sticky top-0 z-50 w-full bg-white/90 backdrop-blur-xl border-b border-slate-200"
    >
      <div className="mx-auto max-w-7xl px-6 sm:px-8 lg:px-12">
        <div className="flex h-20 items-center justify-between">
          <Logo className="text-lg" />

          <nav className="hidden lg:flex items-center gap-9">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                data-testid={`nav-${item.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                className={({ isActive }) =>
                  `text-sm font-medium tracking-wide transition-colors hover:text-gold ${
                    isActive ? "text-gold" : "text-slate-700"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>

          <div className="hidden lg:block">
            <button
              data-testid="navbar-cta-button"
              onClick={() => navigate("/contact")}
              className="bg-navy text-white hover:bg-navy-light transition-colors duration-200 px-6 py-3 text-sm font-medium"
            >
              Request a Consultation
            </button>
          </div>

          <button
            data-testid="mobile-menu-toggle"
            className="lg:hidden text-navy"
            onClick={() => setOpen(!open)}
            aria-label="Toggle menu"
          >
            {open ? <X size={26} /> : <Menu size={26} />}
          </button>
        </div>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="lg:hidden border-t border-slate-200 bg-white">
          <nav className="flex flex-col px-6 py-4">
            {navItems.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                onClick={() => setOpen(false)}
                className="py-3 text-base font-medium text-slate-700 hover:text-gold border-b border-slate-100 last:border-0"
              >
                {item.label}
              </Link>
            ))}
            <button
              onClick={() => {
                setOpen(false);
                navigate("/contact");
              }}
              className="mt-4 bg-navy text-white px-6 py-3 text-sm font-medium"
            >
              Request a Consultation
            </button>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Navbar;
